var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { SubjectStatusSummary } from '@/models/SubjectStatusSummary';
import { Component, Vue, Prop } from 'vue-property-decorator';
let StudentSubjectStatusSummary = class StudentSubjectStatusSummary extends Vue {
    constructor() {
        // File structure for Typescript files in your Vue project
        // https://tutorials.atabix.com/frontend/typscript_file_structure/
        super(...arguments);
        // #endregion
        // #region @Refs
        // #endregion
        // #region Class properties
        this.isLoading = true;
        // #endregion
        // #region Async methods
        // #endregion
        // #region Getters & Setters
        // #endregion
        // #region @Watchers
        // #endregion
    }
    // #endregion
    // #region Lifecycle Hooks / Init
    // #endregion
    // #region Class methods
    getUserStatusDetail(status) {
        return {
            name: 'students.show',
            params: { id: this.summary.user.id || '' },
            query: { statuses: status },
        };
    }
};
__decorate([
    Prop({ required: true }),
    __metadata("design:type", typeof (_a = typeof SubjectStatusSummary !== "undefined" && SubjectStatusSummary) === "function" ? _a : Object)
], StudentSubjectStatusSummary.prototype, "summary", void 0);
StudentSubjectStatusSummary = __decorate([
    Component({
        components: {
        //
        },
    })
], StudentSubjectStatusSummary);
export default StudentSubjectStatusSummary;
